import React from "react"
import { graphql, Link } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"

import "../utils/normalize.css"
import "../utils/css/screen.css"

const ProductPage = ({ data }) => {
  const siteTitle = data.site.siteMetadata.title
  const meta = data.allContentfulProducts.edges[0].node
  // console.log(meta.caution.content[0].content[0])
  return (
    <Layout title={siteTitle}>
      <SEO
        title={meta.name}
        keywords={[`${meta.name}`, `gatsby`, `javascript`, `react`]}
      />

      <article className="post-content page-template no-image">
        <div className="post-content-body">
          <u>
            <h3 id="clean-minimal-and-deeply-customisable-london-is-a-theme-made-for-people-who-appreciate-simple-lines-">
              {meta.name}
            </h3>
          </u>
          {meta.image && (
            <figure className="kg-card kg-image-card">
              <img
                style={{ maxHeight: "300px", objectFit: "contain" }}
                src={meta.image.file.url}
                className="kg-image"
              />
            </figure>
          )}

          {meta.description &&
            meta.description.content[0].content[0].value.split("\n").map(i => {
              return <p>{i}</p>
            })}
          {meta.features && <h4>Some features include:</h4>}
          {meta.features &&
            meta.features.content[0].content[0].value.split("\n").map(i => {
              return <p>{i}</p>
            })}
          {meta.composition && <h4>Composition :</h4>}
          {meta.composition &&
            meta.composition.content[0].content[0].value.split("\n").map(i => {
              return <p>{i}</p>
            })}
          {meta.caution && <h4>Caution for Use :</h4>}
          {meta.caution &&
            meta.caution.content[0].content[0].value.split("\n").map(i => {
              return <p>{i}</p>
            })}
          {meta.packs && <h4>Packs:</h4>}
          <p>
            <p>{meta.packs && meta.packs}</p>
          </p>

          <Link to="/products">
            <p>&#8592; Back to Products</p>
          </Link>
        </div>
      </article>
    </Layout>
  )
}

export default ProductPage

export const pageQuery = graphql`
  query($slug: String!) {
    site {
      siteMetadata {
        title
      }
    }
    allContentfulProducts(filter: { slug: { eq: $slug } }) {
      edges {
        node {
          name
          slug
          category
          image {
            file {
              url
            }
          }

          description {
            content {
              content {
                value
              }
            }
          }
          caution {
            content {
              content {
                value
              }
            }
          }
          features {
            content {
              content {
                value
              }
            }
          }
          composition {
            content {
              content {
                value
              }
            }
          }
          packs
        }
      }
    }
  }
`
